export type ChatMessage = { role: 'user' | 'assistant'; text: string };

const MAX_CHAT_MESSAGES = 60;

export function compactChatMessages(messages: ChatMessage[]): ChatMessage[] {
  const base = Array.isArray(messages) ? messages : [];
  return base
    .filter((m: any) => m && (m.role === 'user' || m.role === 'assistant'))
    .map((m: any) => ({ role: m.role, text: String(m.text ?? '').trim().slice(0, 10_000) }))
    .filter((m) => Boolean(m.text))
    .slice(-MAX_CHAT_MESSAGES);
}

export type RepoContext = {
  github: {
    installationId: number | null;
    repos: Array<{ owner: string; name: string }>;
  };
};

export function normalizeRepoContext(raw: any): RepoContext | null {
  if (!raw || typeof raw !== 'object' || Array.isArray(raw)) return null;
  const installationIdRaw = raw?.github?.installationId ?? null;
  const installationId =
    installationIdRaw == null ? null : typeof installationIdRaw === 'number' ? installationIdRaw : Number(String(installationIdRaw).trim());
  const rawRepos = Array.isArray(raw?.github?.repos) ? raw.github.repos : [];
  const repos = rawRepos
    .map((r: any) => ({
      owner: typeof r?.owner === 'string' ? r.owner.trim() : '',
      name: typeof r?.name === 'string' ? r.name.trim() : '',
    }))
    .filter((r: any) => r.owner && r.name);
  return {
    github: {
      installationId: Number.isFinite(installationId as any) && (installationId as any) > 0 ? (installationId as number) : null,
      repos,
    },
  };
}
